import { Component, OnInit, Input, OnDestroy } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DataService } from 'app/services';
import { datetimeFormat } from 'app/constants/date-time-format';

import { DateService } from 'app/services';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-add-vehicle-history',
  templateUrl: './add-vehicle-history.component.html',
  styleUrls: ['./add-vehicle-history.component.scss'],
})
export class AddVehicleHistoryComponent implements OnInit, OnDestroy {
  @Input() campaign: any = {};
  @Input() preAppliedFilter: any = {};
  @Input('options')
  set setOptions(data: any) {
    this.options = data;
    this.filterOptions.customerFleet = this.options.isFleetFilterOn;
    if (this.options.isShowChatStatus) {
    }
  }
  isSearchEntered: boolean = false;
  options = {
    isSearchBarOn: true, // is search bar visible
    isStatTileVisible: false, // is show stat tile
    isShowAddCustomerButton: true, // show button to add new customer
    isFleetFilterOn: true,
    isShowChatStatus: false,
  };
  customerTags: any[] = [];
  searchResults: any[];
  searchQuery: string = '';
  isLoading: boolean = false;
  filterOptions = {
    status: true,
    tags: true,
    dayFilterOption: false,
    customerFleet: true,
    invoiceDateFilterOption: true,
  };
  isShowVehicleHistory: boolean = false;
  isMultiLocationEnabled: boolean = false;
  shopsMap: any = {};
  vehicleInfo: any = {};
  orderDetails: any = [];
  vehicleId: string = '';
  ownerVehicleHistory: any = [];
  vehicleHistory: any = {};
  vehicleOdmHistory: any = {};
  YMM: any = '';
  ODM: any = {};
  company: any = '';
  dataSubscription: Subscription;
  isTransferVehicleEnabled: boolean = false;
  orderInfo = {
    currentOwner: [],
    previousOwner: [],
  };
  currentOwnerName = '';
  previousOwnerNames = [];
  transferOrderCount = 0;
  constructor(
    public ref: DynamicDialogRef,
    public dateService: DateService,
    private httpService: HTTPService,
    private dataService: DataService,
    private helperService: HelperService,
    private dynamicDialogConfig: DynamicDialogConfig
  ) {}

  ngOnInit() {
    const { vehicleId } = this.dynamicDialogConfig.data;

    this.vehicleId = vehicleId;
    this.setDataListener();

    if (this.vehicleId) {
      this.getVehicleHistoryById();
    }
  }

  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }

  setDataListener() {
    this.isMultiLocationEnabled = this.dataService.isMultiLocationEnabled;
    this.shopsMap = this.dataService.shopsMap;
    this.isTransferVehicleEnabled = this.dataService.isTransferVehicleEnabled;

    this.dataSubscription = this.dataService.getData().subscribe((payload) => {
      if (payload.data && payload.data.key === 'company-appdata-updated') {
        this.isMultiLocationEnabled = this.dataService.isMultiLocationEnabled;
        this.shopsMap = this.dataService.shopsMap;
        this.isTransferVehicleEnabled = this.dataService.isTransferVehicleEnabled;

        this.dataSubscription.unsubscribe();
      }
    });
  }

  getVehicleHistoryById() {
    this.isShowVehicleHistory = false;
    this.httpService.getVehiclePreviousHistory(this.vehicleId).then((data) => {
      this.isShowVehicleHistory = true;
      this.vehicleHistory = data;
      this.orderDetails = data.orderDetails;
      this.vehicleInfo = data.vehicleInfo;
      this.vehicleInfo.createdAt = this.handleVehicleCreationDate();
      if (this.isTransferVehicleEnabled) {
        this.transferVehicleOwnerDetails(data);
      } else {
        this.setOwnerVehicleHistory();
      }

      // if (data && data.orderInfo && data.orderInfo.currentOwner) {
      //   for (const owner of data.orderInfo.currentOwner) {
      //     if (owner && owner.paidDate) {
      //       this.displayPaidDates = new Date(owner.paidDate);
      //     }
      //   }
      // }

      //Set YMM
      this.YMM = this.vehicleInfo.name;

      // Set ODM
      this.ODM = this.vehicleInfo.ODM.slice(-1)[0];

      if (this.vehicleInfo.ODM && this.vehicleInfo.ODM.length) {
        this.vehicleOdmHistory = this.vehicleInfo.ODM.map((odm: any) => ({
          ...odm,
          readingDate: this.dateService.getCurrentDateTimeTz(new Date(odm.readingDate).getTime()),
        }));
      }
      (err) => {
        this.helperService.showToaster('error', err);
        this.isShowVehicleHistory = false;
      };
    });
  }

  transferVehicleOwnerDetails(data, isSearch = false) {
    this.transferOrderCount = 0;
    if (!isSearch) {
      this.previousOwnerNames = [];
    }
    this.orderInfo = {
      currentOwner: [],
      previousOwner: [],
    };
    this.setTransferVehicleHistory(data.orderInfo && data.orderInfo.currentOwner, 'currentOwner');
    if (data.orderInfo && data.orderInfo.previousOwner) {
      data.orderInfo &&
        data.orderInfo.previousOwner.map((x) => {
          x.map((ro: any, i: number) => {
            ro.ownerName = ro.customer.displayName;
            ro.title = `RO # ${ro.code} - ${ro.title}`;
            ro.createdAt = ro.backdatedCreationDate ? ro.backdatedCreationDate : ro.createdAt;
            ro.attachmentCount = ro.attachmentCount || 0;
            ro.estimateId = ro._id;
            ro.isPrevious = i === 0;
            ro.displayPaidDates = ro.paidDate,
            ro.vehicleTransferDetails = this.formatTransferDate(ro);
            x.vehicleTransferDetails = ro.vehicleTransferDetails;
          });
          this.transferOrderCount = x.length + this.transferOrderCount;
        });
      this.orderInfo.previousOwner = data.orderInfo && data.orderInfo.previousOwner;
    }
    if (this.vehicleInfo && this.vehicleInfo.transferHistory && !isSearch) {
      this.previousOwnerNames = this.vehicleInfo.transferHistory;
    }
    if (this.vehicleInfo && this.vehicleInfo.transferDetails && this.vehicleInfo.transferDetails.customerName) {
      this.currentOwnerName = this.vehicleInfo.transferDetails.customerName;
    } else {
      this.currentOwnerName = this.vehicleInfo.customerId.fullName;
    }
  }

  formatTransferDate(ro) {
    if (ro.vehicleTransferDetails && ro.vehicleTransferDetails.vehicleTransferDate) {
      return {
        ...ro.vehicleTransferDetails,
        customerName: ro.customer.displayName,
        vehicleTransferDate: this.dateService.formatDate(ro.vehicleTransferDetails.vehicleTransferDate, datetimeFormat.mmmdyyyy),
      };
    }
    return ro;
  }

  setOwnerVehicleHistory() {
    this.ownerVehicleHistory = [];
    this.orderDetails.forEach((ro: any, i: number) => {
      const obj = {
        shopId: ro.shopId,
        ownerName: ro.customer.displayName,
        title: `RO # ${ro.code} - ${ro.title}`,
        createdAt: ro.backdatedCreationDate ? ro.backdatedCreationDate : ro.createdAt,
        orderStatus: ro.orderStatus,
        vehicleMileage: ro.vehicleMileage,
        workFlowStatus: ro.workFlowStatus,
        services: ro.services,
        serviceWriter: ro.serviceWriter,
        attachments: ro.attachments,
        attachmentCount: ro.attachmentCount || 0,
        inspections: ro.inspections,
        total: ro.total || 0,
        invoiceDate: ro.invoiceDate,
        displayPaidDates: ro.paidDate,
        customerNotes: ro.customerNotes || '',
        shopNotes: ro.shopNotes || '',
        estimateId: ro._id,
        isPaidFull: ro.isPaidFull,
        historyOrder: ro.historyOrder,
      };
      this.ownerVehicleHistory.push(obj);
    });
  }

  showMileageHistory() {
    let history = ``;

    if (this.vehicleOdmHistory && this.vehicleOdmHistory.length > 0) {
      this.vehicleOdmHistory.forEach(({ readingDate, createdBy, reading, mileageMeasuringUnit, estimate }) => {
        /** @todo need to add a handle the 0 condition when flow will updated */
        if (Number(reading) >= 0) {
          history += `
            <div class="tooltip-2">
              <div class="tooltip-secondary-row seondary-row-padding font-12 font-gray-35 d-flex vehicle-tooltip-wrapper">
                <div class="tech-service font-800 font-gray-35 d-flex">
                  <i class="fal fa-clock align-self-start pt-1"></i>
                  <span class="tech-service-title">
                   ${this.dateService.formatDate(readingDate, datetimeFormat.mmmdyyhhmmaa)}
                  </span>
                </div>

                <div class="vehicle-miles font-12 font-gray-45 d-flex">
                      <i class="fal fa-tachometer-fast align-self-start"></i>

                      <span class="tech-service-title">
                        ${reading || 0} ${mileageMeasuringUnit === 'mi' ? 'miles' : 'km' || ''}
                      </span>
                    </div>
                    <div class="vehicle-driver font-12 font-gray-45 d-flex">
                      <i class="fal fa-user-hard-hat align-self-start"></i>

                      <span class="tech-service-title">
                        ${createdBy && createdBy.userName ? createdBy.userName : ''}
                      </span>
                    </div>
                    <div class="vehicle-ro-number font-12 font-gray-45 d-flex">
                      <i class="fal fa-file-alt align-self-start"></i>

                      <span class="tech-service-title">
                        ${estimate && estimate.estimateId ? `RO# ${estimate.code}` : ''}
                      </span>
                    </div>
              </div>
            </div>`;
        }
      });

      return `
        <div class="tooltip-seondary">
          <div class="tooltip-secondary-row font-14 font-bold font-secondary-800 divider-bottom">
            <i class="fal fa-car-mechanic"></i>${this.vehicleInfo.name}
          </div>
          ${history}
        </div>`;
    }

    return '';
  }

  searchClear(): void {
    this.searchResults = [];
    this.searchQuery = '';

    if (this.isSearchEntered) {
      this.getVehicleHistoryById();
      this.isSearchEntered = false;
    }
  }

  /**
   * On Search enter
   */
  onSearchEnter(searchQuery: string): void {
    if (!searchQuery) return;
    this.isSearchEntered = true;
    this.searchQuery = searchQuery;
    // this.table.reset();
  }

  /**
   * Search table
   */
  searchRepairOrder(searchQuery: string): void {
    this.searchQuery = searchQuery;
    this.orderDetails = [];
    this.isSearchEntered = true;
    this.isShowVehicleHistory = false;

    this.httpService.getSearchVehiclePreviousHistory(this.vehicleId, { searchQuery: this.searchQuery }).then((data) => {
      // this.isShowVehicleHistory = true;
      this.vehicleHistory = data;
      this.orderDetails = data.orderDetails;
      this.vehicleInfo = data.vehicleInfo;
      this.vehicleInfo.createdAt = this.handleVehicleCreationDate();
      if (this.isTransferVehicleEnabled) {
        this.transferVehicleOwnerDetails(data, true);
      } else {
        this.setOwnerVehicleHistory();
      }

      //Set YMM
      this.YMM = this.vehicleInfo.name;

      // Set ODM
      this.ODM = this.vehicleInfo.ODM.slice(-1)[0];

      if (this.vehicleInfo.ODM && this.vehicleInfo.ODM.length) {
        this.vehicleOdmHistory = this.vehicleInfo.ODM.map((odm: any) => ({
          ...odm,
          readingDate: this.dateService.getCurrentDateTimeTz(new Date(odm.readingDate).getTime()),
        }));
      }
      (err) => {
        this.helperService.showToaster('error', err);
        this.isShowVehicleHistory = false;
      };
    });
  }

  handleVehicleCreationDate(){
    if (this.vehicleInfo && this.vehicleInfo.createdAt) {
      const createdDate = this.vehicleInfo.createdAt.split('T')[0];
      return this.dateService.formatDate(new Date(`${createdDate}T00:00:00`), datetimeFormat.mmmdyyyy);
    }
  }

  setTransferVehicleHistory(data, type) {
    if (data) {
      data.forEach((ro: any, i: number) => {
        const obj = {
          shopId: ro.shopId,
          ownerName: ro.customer.displayName,
          title: `RO # ${ro.code} - ${ro.title}`,
          createdAt: ro.backdatedCreationDate ? ro.backdatedCreationDate : ro.createdAt,
          orderStatus: ro.orderStatus,
          vehicleMileage: ro.vehicleMileage,
          workFlowStatus: ro.workFlowStatus,
          services: ro.services,
          serviceWriter: ro.serviceWriter,
          attachments: ro.attachments,
          attachmentCount: ro.attachmentCount || 0,
          inspections: ro.inspections,
          total: ro.total || 0,
          invoiceDate: ro.invoiceDate,
          customerNotes: ro.customerNotes || '',
          shopNotes: ro.shopNotes || '',
          estimateId: ro._id,
          isPaidFull: ro.isPaidFull,
          historyOrder: ro.historyOrder,
          isPrevious: type === 'previousOwner' ? true : false,
          vehicleTransferDetails: this.formatTransferDate(ro),
          displayPaidDates :ro.paidDate,
        };
        this.orderInfo[type].push(obj);
      });
      this.transferOrderCount = data.length + this.transferOrderCount;
    }
  }

  closeDialog(data: any) {
    this.ref.close(data);
  }
}
